import React from 'react';
import {
  VaultAccountStatus,
  VaultEntityStatus,
} from '../../services/vault/accountStatus';
import { addDistinct } from '../../util/array';

const EntityParagraph = ({
  items,
  itemName,
}: {
  items: string[];
  itemName: string;
}): JSX.Element | null => {
  if (items.length === 0) {
    return null;
  }
  return (
    <p>
      {itemName}: <em>{items.join(', ')}</em>
    </p>
  );
};

const TooltipEntity = ({
  displayName,
  entityStatus,
}: {
  displayName: string;
  entityStatus?: VaultEntityStatus;
}): JSX.Element | null => {
  if (
    entityStatus === undefined ||
    (entityStatus.missingFields.length === 0 &&
      entityStatus.requiredDocuments.length === 0)
  ) {
    return null;
  }

  return (
    <div>
      <label>
        <b>{displayName}</b>
      </label>
      <EntityParagraph
        items={entityStatus.missingFields}
        itemName='Missing Fields'
      />
      <EntityParagraph
        items={entityStatus.requiredDocuments}
        itemName='Required Documents'
      />
    </div>
  );
};

const Tooltip = ({
  visible,
  accountStatus,
}: {
  visible: boolean;
  accountStatus?: VaultAccountStatus;
}): JSX.Element | null => {
  if (accountStatus === undefined) {
    return null;
  }
  let flatBeneficialOwner: VaultEntityStatus | undefined;
  if (
    accountStatus.beneficialOwnersRequirements !== undefined &&
    accountStatus.beneficialOwnersRequirements.every((bor) => bor !== undefined)
  ) {
    flatBeneficialOwner = {
      missingFields: [],
      requiredDocuments: [],
    };
    for (const beneficialOwner of accountStatus.beneficialOwnersRequirements) {
      addDistinct(
        flatBeneficialOwner.missingFields,
        beneficialOwner.missingFields,
      );
      addDistinct(
        flatBeneficialOwner.requiredDocuments,
        beneficialOwner.requiredDocuments,
      );
    }
  }

  return (
    <div
      role='tooltip'
      className={`
          absolute
          cursor-default
          z-10
          inline-block
          py-2
          text-sm
          font-medium
          text-white
          transition-opacity
          duration-300
          bg-gray-900
          rounded-lg
          shadow-sm
          ${visible ? 'opacity-100' : 'opacity-0'}
          tooltip`}
    >
      <div className='tooltip-arrow'></div>
      <TooltipEntity
        displayName='Kyb'
        entityStatus={accountStatus.kybRequirements}
      />
      <TooltipEntity
        displayName='Account Representative'
        entityStatus={accountStatus.accountRepresentativeRequirements}
      />
      <TooltipEntity
        displayName='Beneficial Owners'
        entityStatus={flatBeneficialOwner}
      />
    </div>
  );
};

export default Tooltip;
